import { MsalGuard } from '@azure/msal-angular';
import type { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    canActivate: [MsalGuard],
    children: [
      {
        loadComponent: () =>
          import('@archimed/refinery-model-exploration').then(
            (module) => module.AssetExplorerComponent,
          ),
        path: 'explore',
      },
    ],

    path: 'refinery',
  },
  {
    canActivate: [MsalGuard],
    loadComponent: () =>
      import('./pages/copilot/copilot.component').then(
        (module) => module.CopilotComponent,
      ),
    path: 'ask-ai',
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'refinery/explore',
  },
];
